<footer class="footer">
  <span class="footer__line">
    ©2000-{{ this.currentYear }}. Rocket Close. All Rights Reserved.</span
  >
</footer>
